<template>
  <div class="ws-app-question">
    <WsCard>
      <div class="ws-app-question__header">
        <div
          class="ws-app-question__header__alert_text"
          v-if="value.isNew"
        >
          NEW
        </div>
        <div
          class="ws-app-question__header__alert_text"
          v-if="value.isCreateVersion"
        >
          UPDATE
        </div>
        <div class="ws-app-question__header__title">{{title}}</div>
        <span class="ws-app-question__header_content">
          {{_nameContent}}
        </span>
        <WsIconBtn
          v-if="expandActive"
          :size="40"
          class="ml-1 mr-1"
          tooltip="收合"
          @click="$_expendActiveToggle()"
        >
          mdi-unfold-less-horizontal
        </WsIconBtn>
        <WsIconBtn
          v-else
          :size="40"
          tooltip="展開"
          class="ml-1 mr-1"
          @click="$_expendActiveToggle()"
        >
          mdi-unfold-more-horizontal
        </WsIconBtn>
        <WsIconBtn
          v-show="editType==='createVersion' && !value.isNew"
          :size="40"
          @click="$_onCreateVersion()"
          tooltip="更新版本"
        >mdi-update</WsIconBtn>
        <WsIconBtn
          v-if="deletable"
          @click="$_deleteAlert()"
          :size="40"
          class="ml-1 mr-1"
          tooltip="刪除"
        >mdi-delete</WsIconBtn>
      </div>
      <div
        class="ws-app-question__content"
        v-show="expandActive"
      >
        <div v-if="isLoading">
          <v-skeleton-loader
            v-for="n in 1"
            :key="`skeleton-${n}`"
            type="list-item-three-line"
            :tile="true"
            class="mt-5"
          ></v-skeleton-loader>
        </div>
        <WsStateForm
          v-if="!value.id || stopFetch"
          :generalFields="fields"
          :value="value"
          :customParentData="parentModelData"
          :modelData="modelData"
          @input="$_onInputForm($event)"
        >
        </WsStateForm>
      </div>
    </WsCard>
    <WsAlertDialog
      ref="deleteDialog"
      title="確定要刪除嗎？"
      description="請再三確認，刪除後的題目將一去不復返。"
      @submit="$_onDelete()"
    />

  </div>
</template>

<script>
export default {
  data: () => ({
    expandActive: false,
    modelData: null,
    isLoading: false,
    stopFetch: false,
  }),
  methods: {
    async $_fetchData() {
      if (!this.value.id || this.stopFetch) return;
      try {
        this.isLoading = true;
        const getUrl = `/${this.modelName}/${this.value.id}`;
        const res = await this.$axios.get(getUrl);
        this.modelData = res.data.data;
        this.$emit("input", res.data.data);
        this.stopFetch = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        alert(error);
      }
    },
    $_onInputForm($event) {
      const _value = { ...this.value, ...$event };
      this.$emit("input", _value);
    },
    $_expendActiveToggle() {
      this.expandActive = !this.expandActive;
    },
    $_deleteAlert() {
      this.$refs.deleteDialog.open();
    },
    $_onDelete() {
      this.$emit("delete");
      this.$refs.deleteDialog.close();
    },
    async $_onCreateVersion() {
      if (!this.stopFetch) await this.$_fetchData();
      this.value.isCreateVersion = this.value.isCreateVersion
        ? !this.value.isCreateVersion
        : true;
      this.$emit("input", this.value);
    },
  },
  computed: {
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _nameContent() {
      if (
        this.value.last_version &&
        this._selectingLocale &&
        this.value.last_version.locales &&
        this.value.last_version.locales[this._selectingLocale]
      ) {
        return this.value.last_version.locales[this._selectingLocale].title;
      } else {
        return "";
      }
    },
  },
  watch: {
    expandActive: {
      handler() {
        this.$_fetchData();
      },
    },
  },
  props: {
    title: {
      type: String,
    },
    value: {
      type: Object,
    },
    fields: {
      type: Object,
    },
    customParentData: {
      type: Function,
    },
    modelName: {
      type: String,
    },
    parentModelData: {
      type: Object,
    },
    editType: {
      type: String,
    },
    deletable: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-app-question";
</style>